import type { MarketSummary } from '@fortem-monorepo/web-sdk'

type MetricUnits = Pick<MarketSummary.ReportRow, 'source_unit' | 'display_metric_unit'>

const fractionScale = (unit: MarketSummary.InstrumentUnit): number | undefined => {
  switch (unit) {
    case 'unit':
    case 'decimal':
      return 1
    case 'pct':
      return 0.01
    case 'bps':
      return 0.0001
    default:
      return undefined
  }
}

/** Optional metric formatting override; prices retain their column formatter. */
export const formatMarketSummaryMetric = (value: unknown, row?: MetricUnits): string | undefined => {
  if (typeof value !== 'number' || !Number.isFinite(value)) return undefined
  const source = row?.source_unit
  const display = row?.display_metric_unit
  if (!source || !display) return undefined

  const sourceScale = fractionScale(source)
  const displayScale = fractionScale(display)
  let converted = value
  if (source !== display) {
    if (sourceScale === undefined || displayScale === undefined) return undefined
    converted = (value * sourceScale) / displayScale
  }
  if (!Number.isFinite(converted)) return undefined
  const formatted = converted.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  return formatted + (display === 'pct' ? '%' : display === 'bps' ? ' bps' : '')
}
